import { render, staticRenderFns } from "./FloatingPanel.vue?vue&type=template&id=4fce1b81&scoped=true"
import script from "./FloatingPanel.vue?vue&type=script&lang=js"
export * from "./FloatingPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatingPanel.vue?vue&type=style&index=0&id=4fce1b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce1b81",
  null
  
)

export default component.exports